import apiClient from "../apiClient";

export const uploadFileAPI = async ({ id_provider, id_patient, formData }) => {
  try {
    const responseFile = await apiClient.post(
      `file-pdf/uploadArchivePDF/${id_provider}/patient/${id_patient}`,
      formData
    );
    return responseFile?.data;
  } catch (error) {
    throw error;
  }
};

export const getFileOfUserAPI = async ({
  id_provider,
  id_patient,
  dateData,
}) => {
  try {
    // console.log(
    //   "UserId:",
    //   id_patient,
    //   "IdProvider:",
    //   id_provider,
    //   "Date data:",
    //   dateData
    // );

    const filesResponse = await apiClient.post(
      `file-pdf/getArchiveById/${id_provider}/patient/${id_patient}`,
      dateData
    );
    return filesResponse?.data?.files ?? [];
  } catch (error) {
    throw error;
  }
};
